import { useEffect } from 'react';
import SessionStorage from '../utils/SessionStorage';
import { 
    AcquisitionFlow, 
    clearSessionAndRedirectToDataEntryPage, 
    getAcquisitionFlow, 
    getCurrentlyInAcquisitionFlow, 
    getDataEntryPages, 
} from '../utils/acquisition-utils';

interface TimeBasedRedirectConfig {
    hours: number;
    timestampKey: string;
    pushdownError: string;
    enabled: boolean;
}

export const useTimeBasedRedirect = ({
    hours,
    timestampKey,
    pushdownError,
    enabled,
}: TimeBasedRedirectConfig): void => {
    useEffect(() => {
        if (!enabled || !getCurrentlyInAcquisitionFlow()) {
            return;
        }

        const dataEntryPages = getDataEntryPages();
        const flow = getAcquisitionFlow();
        const flowURL = {
            [AcquisitionFlow.PA]: dataEntryPages.preApprovalDataEntryPageUrl,
            [AcquisitionFlow.PQ]: dataEntryPages.preQualDataEntryPageUrl,
            [AcquisitionFlow.PqOfOne]: dataEntryPages.pqOfOneDataEntryPageUrl,
            [AcquisitionFlow.SkipPQ]: dataEntryPages.skipPreQualDataEntryPageUrl,
            [AcquisitionFlow.PHA]: dataEntryPages.partnerHostedDataEntryPageUrl,
        }[flow];

        if (!SessionStorage.tryGet(timestampKey, '')) {
            SessionStorage.set(timestampKey, Date.now().toString());
        }

        const HOURS_IN_MS = hours * 60 * 60 * 1000;

        const checkTimeRemaining = () => {
            if (SessionStorage.tryGet('hasExpired', false)) return;

            const storedTime = parseInt(SessionStorage.tryGet(timestampKey, Date.now().toString()));
            const remaining = HOURS_IN_MS - (Date.now() - storedTime);

            if (remaining <= 0) {
                SessionStorage.setObject('hasExpired', true);
                clearSessionAndRedirectToDataEntryPage(pushdownError, flowURL);
            }
        };

        const intervalId = setInterval(checkTimeRemaining, 1000);

        return () => clearInterval(intervalId);
    }, [hours, timestampKey, pushdownError, enabled]);
};
